import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import { ref, computed, watch } from 'vue';

import IconVolumeScale from '@/components/icons/videoplayer/Volume/VolumeScale.vue';
import IconVolumeMute from '@/components/icons/videoplayer/Volume/VolumeMute.vue';
import IconVolumeLow from '@/components/icons/videoplayer/Volume/VolumeLow.vue';
import IconVolumeMedium from '@/components/icons/videoplayer/Volume/VolumeMedium.vue';
import IconVolumeHigh from '@/components/icons/videoplayer/Volume/VolumeHigh.vue';

const cssClass = 'videoplayer';

export default /*@__PURE__*/_defineComponent({
  __name: 'Volume',
  props: {
    currentVolume: {},
    isMuted: { type: Boolean }
  },
  emits: ['click', 'volumeInput'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const volumeInput = ref<number>(1);
const volumeTooltip = computed(() => Math.trunc(volumeInput.value * 100));
const isMuted = computed(() => props.isMuted);

const click = () => {
  emits('click', !isMuted.value);
};

const setVolume = (): void => {
  emits('volumeInput', volumeInput.value);
};

watch(isMuted, (newValue) => {
  if (newValue) {
    volumeInput.value = 0;
  } else if (props.currentVolume === 0) {
    volumeInput.value = 0.5;
    emits('volumeInput', volumeInput.value);
  } else {
    volumeInput.value = props.currentVolume;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${cssClass}__volume`)
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(`${cssClass}__btn`),
      "aria-label": isMuted.value ? 'Включить звук' : 'Выключить звук',
      onClick: click
    }, [
      (isMuted.value)
        ? (_openBlock(), _createBlock(IconVolumeMute, { key: 0 }))
        : (volumeInput.value <= 0.3)
          ? (_openBlock(), _createBlock(IconVolumeLow, { key: 1 }))
          : (volumeInput.value <= 0.7)
            ? (_openBlock(), _createBlock(IconVolumeMedium, { key: 2 }))
            : (_openBlock(), _createBlock(IconVolumeHigh, { key: 3 }))
    ], 10, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(`${cssClass}__volume-progress`)
    }, [
      _createVNode(IconVolumeScale, {
        class: _normalizeClass(`${cssClass}__volume-progress-bar`)
      }, null, 8, ["class"]),
      _withDirectives(_createElementVNode("input", {
        ref: "$volumeInput",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((volumeInput).value = $event)),
        class: _normalizeClass(`${cssClass}__volume-input`),
        type: "range",
        min: "0",
        max: "1",
        step: "0.01",
        "aria-label": "Настроить громкость",
        onInput: setVolume
      }, null, 34), [
        [_vModelText, volumeInput.value]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass([
          `${cssClass}__volume-tooltip`,
          `${cssClass}__tooltip`,
        ])
      }, _toDisplayString(volumeTooltip.value), 3)
    ], 2)
  ], 2))
}
}

})